import { DropdownSelect } from '@components/common';
import { DatePicker } from '@components/common/DatePicker';
import { FormInput, FormTextarea } from '@components/common/FormField';
import React from 'react';
import { useStockTransferFormContext } from './StockTransferFormContext';

export const StockTransferDetailsFields: React.FC = () => {
  const { form, setFormField, locations, uid } = useStockTransferFormContext();

  return (
    <>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <DropdownSelect
          label="From Location"
          value={form.fromLocationId}
          options={locations.map((l) => ({
            value: l.id,
            label: `${l.name} (${l.type})`,
          }))}
          placeholder="Select source"
          onChange={(value) => setFormField('fromLocationId', value)}
        />
        <DropdownSelect
          label="To Location"
          value={form.toLocationId}
          options={locations
            .filter((l) => l.id !== form.fromLocationId)
            .map((l) => ({ value: l.id, label: `${l.name} (${l.type})` }))}
          placeholder="Select destination"
          onChange={(value) => setFormField('toLocationId', value)}
        />
        <DatePicker
          mode="single"
          id={`${uid}-date`}
          label="Transfer Date"
          value={form.transferDate}
          onChange={(iso) => setFormField('transferDate', iso)}
        />
        <FormInput
          id={`${uid}-ref`}
          label="Reference"
          value={form.reference}
          onChange={(e) => setFormField('reference', e.target.value)}
          placeholder="Optional"
        />
      </div>

      <FormTextarea
        id={`${uid}-notes`}
        label="Notes"
        value={form.notes}
        onChange={(e) => setFormField('notes', e.target.value)}
        rows={2}
        placeholder="Optional notes"
      />
    </>
  );
};
